
import React, { useState, useEffect } from 'react';
import './loading.css';
import img1 from "../../../imgs/quran.png";
function Loading() {
    return (
        <div className="loading-container">
            <div id="loader">
                <img className="spinner animate-pulse w-32 h-32"
                    src={img1}
                    alt="Loading..."
                />

                <div className="loading-text">
                    <p className="ArefRuqaaFamily textShadowApp">
                        .. صبراً جميلاً
                    </p>
                    <p className="KleymisskaFamily textShadowApp">
                        Loading Quran...
                    </p>
                </div>
            </div>


        </div>

    );
}


export default Loading;